var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsNavigation24Home(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navigation/24/ic_home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "navigation/24/ic_home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002166,2 C12.6002166,2 13.2002166,2.227 13.6612166,2.68 L21.4202166,10.313 C21.7942166,10.68 22.0082166,11.186 22.0002166,11.71 C21.9712166,13.549 21.8482166,15.387 21.6282166,17.226 C21.3542166,19.524 19.5182166,21.34 17.2212166,21.648 C16.3972166,21.76 15.5732166,21.84 14.7492166,21.898 C14.9892166,20.356 15.0592166,18.814 14.9462166,17.271 C14.8572166,16.062 13.9492166,15.126 12.8592166,15.036 C12.5732166,15.012 12.2872166,15 12.0002166,15 C11.7132166,15 11.4272166,15.012 11.1412166,15.036 C10.0512166,15.126 9.14321658,16.062 9.05421658,17.271 C8.94121658,18.814 9.01121658,20.356 9.25121658,21.898 C8.42721658,21.84 7.60321658,21.76 6.77921658,21.648 C4.48221658,21.34 2.64621658,19.524 2.37221658,17.226 C2.15221658,15.387 2.02921658,13.549 2.00021658,11.71 C1.99221658,11.186 2.20621658,10.68 2.58021658,10.313 L10.3392166,2.68 C10.8002166,2.227 11.4002166,2 12.0002166,2 Z",
    fill: "#494A4A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavigation24Home);
export default __webpack_public_path__ + "static/media/icons_navigation_24_home.42770b4db0629bb2f2c95bfff02340b3.svg";
export { ForwardRef as ReactComponent };